import {remCalc} from '../../_utils'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

const oldCss = {
    '[data-screenset-element-id="gigya-marketing-preferences-screen"]': {
        '.gigya-layout-row.subscribe-wrapper': {
            display: 'flex',
            flexWrap: 'wrap',
            // gap: remCalc(24),
            '.dln-page__sectionHeadTitle': {
                textStyle: {base: 'head-xsmall', lg: 'head-medium'},
                fontSize: {base: remCalc(20), lg: remCalc(28)}, // forced base to head-xsmall desktop view
                lineHeight: {base: remCalc(22), lg: remCalc(30)}, // forced base to head-xsmall desktop view
                fontWeight: 'medium',
                color: 'text.neutral.dark',
                marginTop: remCalc(16),
                marginBottom: remCalc(8),
                width: '100%',
            },
            '.dln-page__sectionHeadInfoText': {
                textStyle: 'body-medium',
                fontWeight: 'normal',
                color: 'text.neutral.dark',
                marginBottom: remCalc(40),
                width: '100%',
            },
            'h2:not(.dln-page__sectionHeadTitle, .dln-page__sectionHeadInfoText)': {
                position: 'absolute',
                zIndex: -1,
            },
            '.gigya-entitlement-checkbox:not([class*="sms"])': {
                position: 'relative',
                height: 'auto',
                width: {base: '100%', lg: remCalc(213)},
                marginRight: {base: 0, lg: remCalc(24)},
                // '&::before': {
                //     content: "''",
                //     // position: 'absolute',
                //     // top: '30%',
                //     display: 'block',
                //     marginBottom: remCalc(24),
                // },
                // '.gigya-input-checkbox': {
                //     margin: remCalc(3),
                // },
                // '&.gigya-delonghi-checkbox::before,   &.gigya-nutribullet-checkbox::before': {
                //     backgroundSize: `${remCalc(144)} ${remCalc(46)}`,
                //     backgroundRepeat: 'no-repeat',
                //     width: remCalc(144),
                //     height: remCalc(46),
                //     // top: '20%',
                //     // '@media only screen and (min-width: 600px)': {top: '30%'},
                // },
                // '&.gigya-nutribullet-checkbox::before': {
                //     backgroundSize: `${remCalc(160)} ${remCalc(26)}`,
                //     backgroundRepeat: 'no-repeat',
                //     width: remCalc(160),
                //     height: remCalc(26),
                //     // top: '28%',
                //     // '@media only screen and (min-width: 600px)': {top: '35%'},
                // },
                // '&.gigya-braun-checkbox::before': {
                //     backgroundSize: `${remCalc(108)} ${remCalc(44)}`,
                //     backgroundRepeat: 'no-repeat',
                //     width: remCalc(108),
                //     height: remCalc(44),
                //     // top: '20%',
                //     // '@media only screen and (min-width: 600px)': {top: '30%'},
                // },
                // '&.gigya-kenwood-checkbox::before': {
                //     backgroundSize: `${remCalc(160)} ${remCalc(24)}`,
                //     backgroundRepeat: 'no-repeat',
                //     width: remCalc(160),
                //     height: remCalc(24),
                //     // top: '30%',
                //     // '@media only screen and (min-width: 600px)': {top: '37%'},
                // },
                // '.gigya-label': {
                //     display: 'flex',
                //     '.gigya-label-text': {marginTop: '3px'},
                // },
                // '@media (min-width: 600px)': {
                //     minHeight: remCalc(180),
                //     maxHeight: remCalc(180),
                //     width: '45%',
                // },
                // '@media (min-width: 900px)': {width: '33.33%'},
                // '@media (min-width: 1200px)': {width: '22%'},
            },
            '.gigya-visible-when': {
                width: {base: '100%', lg: remCalc(213)},
                marginRight: {base: 0, lg: remCalc(24)},
                '.gigya-entitlement-checkbox:not([class*="sms"])': {
                    width: 'auto',
                    marginRight: '0',
                },
                // '@media (min-width: 600px)': {
                //     minHeight: remCalc(180),
                //     maxHeight: remCalc(180),
                //     width: '45%',
                // },
                // '@media (min-width: 900px)': {width: '33.33%'},
                // '@media (min-width: 1200px)': {width: '22%'},
            },
            '.gigya-delonghi-checkbox-sms, .gigya-braun-checkbox-sms, .gigya-kenwood-checkbox-sms, .gigya-nutribullet-checkbox-sms':
                {
                    padding: 0,
                    margin: 0,
                    height: remCalc(20),
                    minHeight: remCalc(20),
                    left: {base: 'calc(-100% + 175px)', lg: remCalc(-237)},
                    top: {base: remCalc(79), lg: remCalc(120)},
                    width: '0 !important',
                    // '@media (min-width: 600px)': {
                    //     top: '175px !important',
                    //     left: 'calc(-22% - 5px) !important',
                    // },
                    // '@media (min-width: 900px)': {left: 'calc(-16% - 5px) !important'},
                    // '@media (min-width: 1200px)': {left: 'calc(-11% - 1px) !important'},
                },
        },
        '.dln-btn--update': {
            width: '100%',
            input: {
                '@include gigya-dln-btn': true,
                width: {base: '100%', lg: remCalc(332)},
                fontWeight: 'bold',
                fontStyle: 'normal',
                fontSize: remCalc(14),
                height: remCalc(40),
            },
        },
    },
    // '.dln-braun': {
    //     '.gigya-delonghi-checkbox-sms, .gigya-braun-checkbox-sms, .gigya-kenwood-checkbox-sms, .gigya-nutribullet-checkbox-sms':
    //         {
    //             display: 'none !important',
    //             left: 'calc(-50% - 2px) !important',
    //             '@media (min-width: 600px)': {
    //                 top: '175px !important',
    //                 left: 'calc(-22% - 7px) !important',
    //             },
    //             '@media (min-width: 900px)': {left: 'calc(-16% - 6px) !important'},
    //             '@media (min-width: 1200px)': {left: 'calc(-11% - 3px) !important'},
    //         },
    // },
    // '.dln-nutribullet': {
    //     '.gigya-delonghi-checkbox-sms, .gigya-braun-checkbox-sms, .gigya-kenwood-checkbox-sms, .gigya-nutribullet-checkbox-sms':
    //         {
    //             left: 'calc(-50% - 3px) !important',
    //             '@media (min-width: 600px)': {left: 'calc(-22% - 7px) !important'},
    //             '@media (min-width: 900px)': {left: 'calc(-16% - 7px) !important'},
    //             '@media (min-width: 1200px)': {left: 'calc(-11% - 3px) !important'},
    //         },
    // },
    // '.dln-kenwood': {
    //     '.gigya-layout-row.subscribe-wrapper': {
    //         '.gigya-label-text': {width: 'auto !important'},
    //         '.gigya-delonghi-checkbox-sms,  .gigya-braun-checkbox-sms,  .gigya-kenwood-checkbox-sms,  .gigya-nutribullet-checkbox-sms':
    //             {
    //                 left: 'calc(-50% - 4px) !important',
    //                 '@media (min-width: 600px)': {left: 'calc(-22% - 8px) !important'},
    //                 '@media (min-width: 768px)': {left: 'calc(-22% - 3px) !important'},
    //                 '@media (min-width: 900px)': {left: 'calc(-16% - 3px) !important'},
    //                 '@media (min-width: 1200px)': {left: 'calc(-11%) !important'},
    //             },
    //     },
    // },
    '.gigya-layout-row:nth-child(4)': {
        display: 'flex',
        flexWrap: 'wrap',
        padding: remCalc(24),
        borderColor: 'border.light',
        borderStyle: 'solid',
        borderWidth: remCalc(1),
        borderRadius: 'large',
        mb: remCalc(24),
        '.gigya-custom-checkbox': {
            width: 'calc(100% - 30px)',
            margin: '0 !important',
            position: 'relative',
            input: {
                position: 'absolute',
                zIndex: -1,
            },
            label: {
                fontWeight: 'normal',
                textStyle: 'body-small',
                paddingLeft: remCalc(24),
                zIndex: 1,
                a: {
                    textDecoration: 'underline',
                    fontWeight: 'bold',
                },
            },
            '&:before': {
                position: 'absolute',
                content: '""',
                display: 'block',
                boxSizing: 'border-box',
                width: remCalc(16),
                height: remCalc(16),
                borderRadius: 'medium',
                backgroundColor: '#f4f3f1',
                boxShadow:
                    '0 0 0 1px rgba(19,24,58,.56), 0 1px 2px rgba(19,24,58,.08), inset 0 0 0 1px #fff',
                border: '1px solid #fff',
                top: remCalc(4),
                left: 0,
            },
            '&:after': {
                position: 'absolute',
                display: 'none',
                content: '""',
                width: remCalc(5),
                height: remCalc(9),
                top: remCalc(7),
                left: remCalc(6),
                transform: 'rotate(45deg)',
                borderWidth: '0 2px 2px 0',
                borderColor: '#efedea',
                borderStyle: 'solid',
            },
            '&:has(.gigya-input-checkbox:checked):before': {
                backgroundColor: 'background.base.check-icon-modal',
                boxShadow:
                    '0 0 0 1px rgba(19,24,58,.08), 0 1px 2px rgba(19,24,58,.08), inset 0 0 0 1px #fff',
            },
            '&:has(.gigya-input-checkbox:checked):after': {
                display: 'block',
            },
        },
        '.gigya-toggle': {
            width: remCalc(30),
            textAlign: 'right',
            margin: '0 !important',
        },
        '.gigya-toggle-content': {
            fontSize: remCalc(11),
            lineHeight: remCalc(16),
            fontWeight: 'normal',
            fontStyle: 'normal',
            margin: `${remCalc(21)} 0 0 !important`,
        },
        '.dln-checkbox__confirmText': {
            textStyle: 'body-small',
            fontWeight: 'bold',
            width: '100%',
            marginTop: remCalc(16),
            marginBottom: remCalc(32),
        },
        '.dln-btn--link': {
            width: {base: '100%', lg: '20%'},
            display: 'flex',
            alignItems: 'center',
            justifyContent: {base: 'center', lg: 'flex-start'},
            textStyle: 'body-medium',
            color: 'text.tertiary',
            textDecoration: 'underline',
            fontWeight: 'bold',
            height: remCalc(40),
        },
        '.dln-btn--confirm': {
            width: {base: '100%', lg: '80%'},
            display: 'flex',
            justifyContent: 'flex-end',
            input: {
                '@include gigya-dln-btn': true,
                width: {base: '100%', lg: remCalc(332)},
                fontWeight: 'bold',
                fontStyle: 'normal',
                fontSize: remCalc(14),
                height: remCalc(40),
            },
        },
    },
    // '.language-zh': {
    //     '#js-gigya-screenset-marketing-privacy': {
    //         '.gigya-screen-content': {
    //             '.gigya-profile-form': {
    //                 '>.gigya-layout-row:nth-of-type(2)': {
    //                     display: 'flex',
    //                     flexWrap: 'wrap',
    //                     padding: remCalc(21),
    //                 },
    //                 '.gigya-layout-row:nth-child(4)': {display: 'none'},
    //             },
    //             '.gigya-toggle': {alignSelf: 'center'},
    //             '.dln-checkbox__confirmText': {
    //                 textStyle: 'body-small',
    //                 fontWeight: 700,
    //                 width: '100%',
    //                 marginTop: remCalc(16),
    //                 marginBottom: remCalc(32),
    //             },
    //             '.dln-page__sectionHeadTitle': {
    //                 textStyle: 'head-medium',
    //                 fontWeight: 500,
    //                 marginTop: remCalc(16),
    //                 marginBottom: remCalc(8),
    //                 width: '100%',
    //             },
    //             '.dln-page__sectionHeadInfoText': {
    //                 textStyle: 'body-medium',
    //                 fontWeight: 400,
    //                 marginBottom: remCalc(40),
    //                 width: '100%',
    //             },
    //             '.dln-btn--link': {
    //                 width: '20%',
    //                 display: 'flex',
    //                 alignItems: 'center',
    //                 justifyContent: 'flex-start',
    //                 textStyle: 'body-medium',
    //                 color: 'text.default',
    //                 textDecoration: 'underline',
    //                 fontWeight: 700,
    //             },
    //             '.dln-btn--confirm': {
    //                 width: '80%',
    //                 display: 'flex',
    //                 justifyContent: 'flex-end',
    //                 '.gigya-input-submit': {
    //                     width: remCalc(280),
    //                     outline: 'none',
    //                     textAlign: 'center',
    //                     border: 'none',
    //                     boxShadow: 'none',
    //                     transition: 'all .3s linear',
    //                     overflow: 'hidden',
    //                     cursor: 'pointer',
    //                     height: remCalc(40),
    //                 },
    //             },
    //             '.gigya-composite-control.gigya-composite-control-link.gigya-toggle': {
    //                 width: remCalc(30),
    //                 textAlign: 'right',
    //                 margin: '0',
    //             },
    //             '.gigya-composite-control-link:focus': {border: 'none'},
    //             '.gigya-checkbox-text': {position: 'relative'},
    //         },
    //         '.gigya-layout-ro': {
    //             display: 'flex',
    //             justifyContent: 'center',
    //             flexWrap: 'wrap',
    //             '.gigya-entitlement-checkbox': {
    //                 position: 'relative',
    //                 textAlign: 'center',
    //                 minHeight: remCalc(130),
    //                 display: 'flex',
    //                 justifyContent: 'center',
    //                 alignItems: 'flex-end',
    //                 padding: remCalc(20),
    //                 width: '100%',
    //                 '.gigya-label-text.gigya-checkbox-text': {display: 'none'},
    //                 '&::before': {
    //                     content: "''",
    //                     position: 'absolute',
    //                     top: '30%',
    //                     display: 'block',
    //                 },
    //                 '.gigya-input-checkbox': {
    //                     position: 'absolute',
    //                     top: remCalc(-99999),
    //                     left: remCalc(-99999),
    //                     '+label': {
    //                         '&::before,      &::after': {position: 'relative'},
    //                         '&::after': {top: '-12px'},
    //                     },
    //                 },
    //                 '&.gigya-delonghi-checkbox::before,    &.gigya-nutribullet-checkbox::before': {
    //                     backgroundImage: "url('#{$pathAssets}/images/logos/logo-delonghi.svg')",
    //                     backgroundSize: `${remCalc(144)} ${remCalc(46)}`,
    //                     backgroundRepeat: 'no-repeat',
    //                     width: remCalc(144),
    //                     height: remCalc(46),
    //                     top: '20%',
    //                     '@media only screen and (min-width: 600px)': {top: '30%'},
    //                 },
    //                 '&.gigya-nutribullet-checkbox::before': {
    //                     backgroundImage: "url('#{$pathAssets}/images/logos/logo-nutribullet.svg')",
    //                     backgroundSize: `${remCalc(160)} ${remCalc(26)}`,
    //                     backgroundRepeat: 'no-repeat',
    //                     width: remCalc(160),
    //                     height: remCalc(26),
    //                     top: '28%',
    //                     '@media only screen and (min-width: 600px)': {top: '35%'},
    //                 },
    //                 '&.gigya-braun-checkbox::before': {
    //                     backgroundImage: "url('#{$pathAssets}/images/logos/logo-braun.svg')",
    //                     backgroundSize: `${remCalc(108)} ${remCalc(44)}`,
    //                     backgroundRepeat: 'no-repeat',
    //                     width: remCalc(108),
    //                     height: remCalc(44),
    //                     top: '20%',
    //                     '@media only screen and (min-width: 600px)': {top: '30%'},
    //                 },
    //                 '&.gigya-kenwood-checkbox::before': {
    //                     backgroundImage: "url('#{$pathAssets}/images/logos/logo-kenwood.svg')",
    //                     backgroundSize: `${remCalc(160)} ${remCalc(24)}`,
    //                     backgroundRepeat: 'no-repeat',
    //                     width: remCalc(160),
    //                     height: remCalc(24),
    //                     top: '30%',
    //                     '@media only screen and (min-width: 600px)': {top: '37%'},
    //                 },
    //                 '@media (min-width: 600px)': {
    //                     minHeight: remCalc(180),
    //                     maxHeight: remCalc(180),
    //                     width: '45%',
    //                 },
    //                 '@media (min-width: 900px)': {width: '33.33%'},
    //                 '@media (min-width: 1200px)': {width: '22%'},
    //             },
    //             '.gigya-visible-when': {
    //                 width: '100%',
    //                 '@media (min-width: 600px)': {
    //                     minHeight: remCalc(180),
    //                     maxHeight: remCalc(180),
    //                     width: '45%',
    //                 },
    //                 '@media (min-width: 900px)': {width: '33.33%'},
    //                 '@media (min-width: 1200px)': {width: '22%'},
    //                 '.gigya-entitlement-checkbox': {width: '100%'},
    //             },
    //             '.dln-btn--update': {
    //                 textAlign: ['right', 'center'],
    //                 marginTop: remCalc(40),
    //                 paddingTop: remCalc(30),
    //                 width: '100%',
    //                 input: {
    //                     '@include gigya-dln-btn': true,
    //                     width: remCalc(280),
    //                     fontWeight: 700,
    //                     fontStyle: 'normal',
    //                     fontSize: remCalc(14),
    //                     height: remCalc(40),
    //                 },
    //             },
    //         },
    //     },
    // },
    // '.language-zh.dln-kenwood': {
    //     '#js-gigya-screenset-marketing-privacy': {
    //         '.gigya-input-submit': {backgroundColor: '#d11b59'},
    //         '.dln-btn--update': {paddingTop: '30px !important', textAlign: 'right'},
    //         '.gigya-screen-content': {
    //             '.gigya-profile-form': {
    //                 '>.gigya-layout-row:nth-of-type(2)': {
    //                     border: 'none',
    //                     borderBottom: '1px solid',
    //                 },
    //                 '.gigya-layout-row:nth-child(4)': {display: 'none'},
    //             },
    //         },
    //     },
    // },
    // '.dln-braun.language-zh': {
    //     '#js-gigya-screenset-marketing-privacy': {
    //         '.dln-page__sectionHeadTitle,  .dln-page__sectionHeadInfoText': {
    //             textAlign: 'left',
    //         },
    //         '.gigya-input-submit': {borderRadius: '20px'},
    //     },
    // },
}

export default {
    baseStyle: () => {
        const braunLogo = getAssetUrl('static/img/marketing-preference/braun-logo.svg')
        const delonghiLogo = getAssetUrl('static/img/marketing-preference/delonghi-logo.svg')
        const kenwoodLogo = getAssetUrl('static/img/marketing-preference/kenwood-logo.svg')
        const nutribulletLogo = getAssetUrl('static/img/marketing-preference/nutribullet-logo.svg')

        return {
            accountContainer: {
                w: '100%',
                paddingY: remCalc(100),
                paddingInline: {base: remCalc(16), md: remCalc(24)},
                paddingTop: {base: 0, md: remCalc(16), lg: remCalc(80)},
            },
            accountTitle: {
                fontSize: {base: remCalc(28), lg: remCalc(40)},
                lineHeight: {base: remCalc(30), lg: remCalc(38)},
                fontWeight: 700,
                paddingTop: remCalc(24),
                paddingBottom: {base: remCalc(16), lg: remCalc(24)},
                marginBottom: {base: remCalc(24), lg: remCalc(40)},
                borderBottom: 'small',
                borderColor: 'border.light',
                outline: 'none',
                color: 'text.neutral.dark',
            },
            accountDetailContainer: {
                gap: 0,
            },
            personalInformationTitle: {
                fontSize: remCalc(16),
                color: '#13183a',
                fontWeight: 700,
            },
            '.separator-wrapper': {
                height: remCalc(1),
                marginY: remCalc(30),
            },
            '.gigya-input-submit': {
                w: '100%',
                display: 'inline-flex',
                maxW: '100%',
                outlineWidth: 0,
                textStyle: 'body-medium',
                fontWeight: 'bold',
                alignItems: 'center',
                padding: `${remCalc(10)} ${remCalc(24)}`,
                maxHeight: remCalc(40),
                bg: 'button.background.primary-default',
                borderRadius: [
                    'button.radius.primary-default.base',
                    'button.radius.primary-default.sm',
                    'button.radius.primary-default.md',
                    'button.radius.primary-default.lg',
                ],
                '.gigya-style-modern div.gigya-screen-dialog-main': {
                    backgroundColor: 'background.default',
                    padding: remCalc(20),
                    maxwidth: remCalc(540),
                },
                '.gigya-style-modern div.gigya-screen-dialog-top': {
                    padding: 0,
                    border: 0,
                    lineHeight: 0,
                    backgroundColor: 'background.default',
                },
                color: 'button.text.primary-default',
                _hover: {
                    bg: 'button.background.primary-hover',
                },
                _focus: {
                    border: remCalc(2),
                    borderColor: 'button.border.primary-focused',
                    borderStyle: 'solid',
                    bg: 'button.background.primary-focused',
                },
                _disabled: {
                    bg: 'background.accent.muted',
                    color: 'foreground.neutral.inverse',
                    _hover: {
                        bg: 'background.accent.muted !important',
                        color: 'foreground.neutral.inverse !important',
                    },
                },
                _pressed: {
                    bg: 'button.background.primary-pressed',
                    color: 'button.text.primary-pressed',
                },
            },
            '.dlg-gigya-button-wrapper input[type=button], .dlg-gigya-button-wrapper input[type=submit]':
                {
                    outline: 'none',
                    textStyle: 'body-medium',
                    textAlign: 'center',
                    boxShadow: 'none',
                    transition: 'all .3s linear',
                    WebkitAppearance: 'none',
                    MozAppearance: 'none',
                    cursor: 'pointer',
                    WebkitUserSelect: 'none',
                    userSelect: 'none',
                    height: remCalc(40),
                    padding: 0,
                    textDecoration: 'none',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    borderRadius: [
                        'button.radius.primary-default.base',
                        'button.radius.primary-default.sm',
                        'button.radius.primary-default.md',
                        'button.radius.primary-default.lg',
                    ],
                    overflow: 'hidden',
                    width: {base: '100%', lg: remCalc(332)},
                    fontStyle: 'body-medium',
                    fontWeight: 'medium',
                },
            '.gigya-password-input-container': {
                position: 'relative',
                width: '100%',
            },
            '.gigya-composite-control': {
                position: 'relative',
            },
            '.dlg-gigya-input-text-wrapper input': {
                borderRadius: '2px !important',
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.dark',
                color: 'text.default',
                textStyle: 'body-small',
                outline: '0',
                width: '100%',
                lineHeight: remCalc(16),
                backgroundColor: 'transparent !important',
                padding: `${remCalc(14)} ${remCalc(8)} ${remCalc(8)}`,
                boxSizing: 'border-box',
                appearance: 'none',
            },
            '.dlg-gigya-input-text-wrapper .gigya-label': {
                lineHeight: '150%',
                font: 'inherit',
                display: 'inline-block',
                color: 'text.secondary',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                transformOrigin: '0 0',
                transition:
                    'top .4s cubic-bezier(.25,.8,.25,1), transform .4s cubic-bezier(.25,.8,.25,1), color .4s cubic-bezier(.25,.8,.25,1), width .4s cubic-bezier(.25,.8,.25,1)',
                padding: `0 ${remCalc(4)}`,
                overflow: 'hidden',
                pointerEvents: 'none',
                position: 'absolute',
                top: 'calc(50% - 21px)',
                left: remCalc(8),
                zIndex: '1',
                textStyle: 'body-small',
            },
            '.dlg-gigya-input-text-wrapper.focus-visible + .gigya-label': {
                backgroundColor: 'background.default',
                transform: 'translateY(calc(50% - 29px)) scale(.75)',
            },
            '.gigya-composite-control-textbox:focus-within .gigya-label': {
                transform: 'translateY(calc(50% - 29px)) scale(0.75)',
                backgroundColor: 'background.default',
                color: 'border.dark',
            },
            '.gigya-composite-control-password:focus-within .gigya-label': {
                transform: 'translateY(calc(50% - 29px)) scale(0.75)',
                backgroundColor: 'background.default',
                color: 'border.dark',
            },
            '.gigya-spacer': {
                height: remCalc(24),
            },
            '.hr--solid:': {
                width: '100%',
                height: remCalc(1),
                backgroundColor: 'border.light',
                margin: `${remCalc(24)} 0`,
            },
            '.dln-registrationForm__paragraph': {
                textStyle: 'body-small',
                color: 'text.default',
            },
            '.dlg-hidden': {
                display: 'none',
            },
            '.dln-completeForm__paragraph': {
                textStyle: 'body-xxsmall',
                lineHeight: '125%',
                width: ' 100%',
                color: 'text.default',
                margin: `0 0 ${remCalc(16)}`,
            },
            '.dln-completeForm__paragraph--secondary': {
                textStyle: 'body-small',
                color: 'text.secondary',
                lineHeight: '125%',
                marginBottom: {base: remCalc(24), lg: remCalc(24)},
                display: 'inline-block',
            },
            '.dln-completeForm__paragraph--secondary:not(h2, label)': {
                display: 'flex',
                gap: remCalc(8),
                alignItems: 'center',
            },
            '.gigya-composite-control-checkbox .gigya-checkbox-text': {
                textStyle: 'body-small',
                fontWeight: 'medium',
                color: 'background.base.inverse',
                transition: 'color .12s linear',
            },
            '.dln-registrationForm__paragraph--secondary': {
                display: 'none',
            },
            '.is-hidden': {display: 'none !important'},
            '.gigya-composite-control-checkbox .gigya-checkbox-text button.dln-icn.dln-icn--iconfont':
                {
                    display: 'none',
                },
            '.gigya-sms-disabled .gigya-delonghi-checkbox-sms': {
                display: 'none !important',
            },
            ...oldCss,
            '[data-screenset-element-id="gigya-marketing-preferences-screen"]': {
                '.gigya-layout-row.subscribe-wrapper': {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: remCalc(24),
                    paddingTop: remCalc(40),
                    '.dln-page__sectionHeadTitle': {
                        fontSize: remCalc(28),
                        lineHeight: remCalc(30),
                        fontWeight: 500,
                        color: '#13183a',
                        marginTop: 0,
                        marginBottom: 0,
                        width: '100%',
                    },
                    '.dln-page__sectionHeadInfoText': {
                        fontSize: remCalc(16),
                        lineHeight: remCalc(20),
                        fontWeight: 400,
                        color: '#13183a',
                        marginBottom: remCalc(16),
                        width: '100%',
                        a: {
                            color: '#5d5f69',
                            textDecoration: 'underline',
                        },
                    },
                    'h2:not(.dln-page__sectionHeadTitle, .dln-page__sectionHeadInfoText)': {
                        position: 'absolute',
                        zIndex: -1,
                    },
                    '.gigya-entitlement-checkbox:not([class*="sms"])': {
                        position: 'relative',
                        height: 'auto',
                        width: {base: '100%', lg: remCalc(213)},
                        marginRight: 0,
                    },
                    '.gigya-visible-when': {
                        width: {base: '100%', lg: remCalc(213)},
                        marginRight: 0,
                        '.gigya-entitlement-checkbox:not([class*="sms"])': {
                            width: 'auto',
                            marginRight: '0',
                        },
                    },
                    '.gigya-delonghi-checkbox-sms, .gigya-braun-checkbox-sms, .gigya-kenwood-checkbox-sms, .gigya-nutribullet-checkbox-sms':
                        {
                            padding: 0,
                            margin: 0,
                            height: remCalc(20),
                            minHeight: remCalc(20),
                            left: {base: 'calc(-100% + 175px)', lg: remCalc(-237)},
                            top: {base: remCalc(79), lg: remCalc(120)},
                            width: '0 !important',
                        },
                },
                '.dln-btn--update': {
                    width: '100%',
                    marginTop: remCalc(40),
                    input: {
                        width: {base: '100%', lg: remCalc(332)},
                        height: remCalc(40),
                        background: '#001787',
                        color: '#efedea',
                        borderRadius: '999px',
                        border: 'none',
                        fontSize: remCalc(16),
                        fontWeight: 500,
                        lineHeight: '1.15',
                        letterSpacing: '-0.16px',
                        cursor: 'pointer',
                        padding: `${remCalc(12)} ${remCalc(24)}`,
                        transition: 'background .15s ease',
                        boxSizing: 'border-box',
                        outlineWidth: 0,
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        '&:hover': {
                            background: '#374b8a',
                        },
                        '&:disabled': {
                            background: '#8a95b7',
                            cursor: 'not-allowed',
                        },
                    },
                },
            },
            '[data-screenset-element-id="gigya-marketing-preferences-screen"] .gigya-layout-row.subscribe-wrapper .gigya-entitlement-checkbox':
                {
                    '&:before': {
                        content: "''",
                        display: 'block',
                    },
                    '&:not([class*="sms"]):before': {
                        marginBottom: remCalc(24),
                        height: remCalc(56),
                        width: remCalc(175),
                        backgroundPosition: 'left center',
                        backgroundRepeat: 'no-repeat',
                    },
                    '&.gigya-delonghi-checkbox:before': {
                        backgroundImage: `url("${delonghiLogo}")`,
                        backgroundSize: `${remCalc(175)} auto`,
                    },
                    '&.gigya-braun-checkbox:before': {
                        backgroundImage: `url("${braunLogo}")`,
                        backgroundSize: `auto ${remCalc(56)}`,
                    },
                    '&.gigya-kenwood-checkbox:before': {
                        backgroundImage: `url("${kenwoodLogo}")`,
                        backgroundSize: `${remCalc(175)} auto`,
                    },
                    '&.gigya-nutribullet-checkbox:before': {
                        backgroundImage: `url("${nutribulletLogo}")`,
                        backgroundSize: `${remCalc(175)} auto`,
                    },
                    '& > input': {
                        position: 'absolute',
                        opacity: 0,
                        zIndex: -1,
                        height: 0,
                        width: 0,
                    },
                    '& > label': {
                        display: 'flex',
                        alignItems: 'flex-start',
                        position: 'relative',
                        paddingLeft: remCalc(24),
                        gap: remCalc(8),
                        cursor: 'pointer',
                        fontSize: remCalc(14),
                        lineHeight: remCalc(16),
                        fontWeight: 500,
                        color: '#13183a',
                        width: remCalc(175),
                    },
                    '& > label:before': {
                        position: 'absolute',
                        content: '""',
                        display: 'block',
                        top: '50%',
                        left: 0,
                        transform: 'translateY(-50%)',
                        boxSizing: 'border-box',
                        width: remCalc(16),
                        height: remCalc(16),
                        borderRadius: 'medium',
                        backgroundColor: '#f4f3f1',
                        boxShadow:
                            '0 0 0 1px rgba(19,24,58,.56), 0 1px 2px rgba(19,24,58,.08), inset 0 0 0 1px #fff',
                        border: '1px solid #fff',
                        flexShrink: 0,
                        zIndex: 1,
                    },
                    '& > label > span:before': {
                        position: 'absolute',
                        display: 'none',
                        content: '""',
                        width: remCalc(6),
                        height: remCalc(11),
                        top: remCalc(2),
                        left: remCalc(5),
                        transform: 'rotate(45deg)',
                        borderWidth: '0 2px 2px 0',
                        borderColor: '#efedea',
                        borderStyle: 'solid',
                        zIndex: 2,
                    },
                    '&:has(.gigya-input-checkbox:checked) > label:before': {
                        backgroundColor: 'background.base.check-icon-modal',
                        boxShadow:
                            '0 0 0 1px rgba(19,24,58,.08), 0 1px 2px rgba(19,24,58,.08), inset 0 0 0 1px #fff',
                    },
                    '&:has(.gigya-input-checkbox:checked) > label > span:before': {
                        display: 'block',
                        width: remCalc(4),
                        height: remCalc(10),
                        top: remCalc(9),
                        left: remCalc(7),
                    },
                },
        }
    },
}
